import {useMutation, useQueryClient} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {PostAccessManagementPermissionsParams} from 'domain/usecases/private/profile/post-access-management-permissions';
import {GetAccessManagementPermissionsResponse} from 'domain/usecases';
import {postAccessManagementPermissions} from '../../services/postAccessManagementPermissions';

export function usePostAccessManagementPermissionsMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: PostAccessManagementPermissionsParams) => {
			const response = await postAccessManagementPermissions(params);

			if (!response.success) {
				throw new Error(response.message);
			}

			return response;
		},
		onSuccess: (_response, permissions) => {
			const updatedPermission = permissions[0];

			if (updatedPermission) {
				queryClient.setQueriesData<GetAccessManagementPermissionsResponse>(
					{queryKey: [QUERY_KEYS.ACCESS_MANAGEMENT_PERMISSIONS]},
					current => {
						if (!current) return current;

						return {
							...current,
							compartilheAcessoSeuPlano: current.compartilheAcessoSeuPlano.map(
								item =>
									item.cdPessoaMembro === updatedPermission.cdPessoaMembro &&
									item.cdUsuarioMembro === updatedPermission.cdUsuarioMembro &&
									item.nuOrdemUsuarioMembro === updatedPermission.nuOrdemUsuario
										? {
												...item,
												flPermitido: updatedPermission.permitido
													? 'S'
													: 'N',
											}
										: item,
							),
						};
					},
				);
			}

			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.ACCESS_MANAGEMENT_PERMISSIONS],
			});
		},
	});
}
